import { render } from "./ChildAccountCreate.vue?vue&type=template&id=6148bafe&ts=true"
import script from "./ChildAccountCreate.vue?vue&type=script&lang=ts"
export * from "./ChildAccountCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__